module.exports = __webpack_public_path__ + "img/yycf.202f265e.png";